import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { queryEpicStoreOffers } from '../../../external_node_modules/@wg/web2clientapi/platform/EpicGamesStore/queryEpicStoreOffers.js';
import { getStorefrontByPlatform } from '../../../api/storefront.js';
import { validateProducts } from '../../../api/validate.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { ProductEntity } from '../../entity/product.entity.js';
import { getMockedOffers } from './utils/mock.js';
import settings from '../../../settings.js';
import { warn } from '../../../utils/logger.js';
import { memoizeAsync } from '../../../utils/memoize.js';

const getEpicStoreOffers = memoizeAsync(queryEpicStoreOffers.name, queryEpicStoreOffers);
function fetchOffers(useClientMocks, customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        if (useClientMocks) {
            return yield getMockedOffers(customStorefrontName);
        }
        const { data } = yield getEpicStoreOffers();
        return data.offers;
    });
}
const getOffers = memoizeAsync(fetchOffers.name, fetchOffers);
function fetchProductsObject(customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const [offers, storefront] = yield Promise.all([
            getOffers(settings.useClientMocks, customStorefrontName),
            getStorefrontByPlatform(PLATFORMS.EGS, customStorefrontName),
        ]);
        const products = Object.values(storefront.products || {});
        const productsEntities = {};
        for (const product of products) {
            const offer = offers.find((offer) => product.externalProductId === offer.offerId);
            if (!offer) {
                warn('[EGS]', 'Cannot merge product with offer', product.externalProductId, product, offers);
                continue;
            }
            const mergedProduct = Object.assign(Object.assign(Object.assign({}, product), offer), { title: product.title });
            productsEntities[product.id] = new ProductEntity(mergedProduct, PLATFORMS.EGS, settings.language, settings.country);
        }
        if (settings.productsValidationEnabled) {
            validateProducts(Object.values(productsEntities), PLATFORMS.EGS);
        }
        return productsEntities;
    });
}
const getProductsObject = memoizeAsync(fetchProductsObject.name, fetchProductsObject);
function getProducts(customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        return Object.values(yield getProductsObject(customStorefrontName));
    });
}

export { getEpicStoreOffers, getProducts, getProductsObject };
//# sourceMappingURL=products.js.map
